<div
  aria-live="polite"
  aria-atomic="true"
  data-testid="services-unavailable-component"
  class="flex flex-col items-center gap-3 text-center"
>
  @if (showStatus()) {
    <i class="h-12 w-12 bg-[url(../assets/icons/unavailable-area-icon.svg)] p-2"></i>
    <div class="text-lg font-bold">Online service request is unavailable in your area!</div>
    <div class="text-sm font-normal">
      <p>
        Online service request is currently available in
        <button
          #citiesButton
          type="button"
          [disabled]="isCitiesDialogOpen()"
          class="relative cursor-pointer rounded-sm underline focus:outline focus-visible:outline-2 focus-visible:outline-offset-1"
          (click)="openCitiesDialog()"
        >
          select areas
          @if (isCitiesDialogOpen()) {
            <csl-icon
              name="loader-icon"
              class="absolute right-[-20px] top-0 size-5 animate-spin bg-blue-900"
            ></csl-icon>
          }</button
        >.
      </p>
      <p>
        If you want to order service in other city please contact us at
        <a
          href="mailto:{{ contactEmail }}"
          target="_blank"
          class="rounded-sm underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1"
          >{{ contactEmail }}</a
        >
        or
        <a
          href="tel:{{ contactPhone }}"
          class="rounded-sm underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1"
          >{{ contactPhone | phone: 'XXX-XXX-XXXX' }}</a
        >
      </p>
    </div>

    <div class="flex gap-2 pb-4 text-base font-medium">
      <a
        cslButton="secondary-link"
        target="_blank"
        [href]="contactUsUrl"
        (click)="contactUsClick.emit(contactUsUrl)"
        data-testid="services-unavailable-contact-us-link"
      >
        Contact us
        <csl-icon name="arrow_right" class="size-6 -rotate-45 bg-blue-900"></csl-icon>
      </a>
    </div>
  }
</div>
